import { useHistory } from 'react-router-dom';

import { useQueryClient, useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { GENERIC_ERROR_MESSAGE } from '../../constants/error-message';
// constants
import routes from '../../constants/routes';

import { BaseError } from './../../helpers/BaseError';

import { FormulaCloneModel } from '../../models/formula.model';

// services
import API from '../../services/api';
import { toastService } from '../../services/toast.service';

// hooks
import useAnalytics from '../helper/useAnalytics';
import formulaKeys from './_queryKeys';

export default function useFormulaClone() {
    const queryClient = useQueryClient();
    const history = useHistory();

    const { track } = useAnalytics();

    return useMutation<
        AxiosResponse<{ id: number; formula_id: number }>,
        BaseError,
        FormulaCloneModel
    >({
        mutationFn: API.cloneFormula,
        onSuccess: ({ data }) => {
            toastService.showSuccess('Message cloned successfully');
            history.replace(routes.formulaDraft(data.id));
            track('formula_cloned', {
                clone_formula_id: data.formula_id,
                cloned_formula_id: data.id,
            });
            queryClient.invalidateQueries({ queryKey: formulaKeys.all });
        },
        onError: () => {
            toastService.showError(GENERIC_ERROR_MESSAGE);
        },
    });
}
